import React from 'react';
import PropTypes from 'prop-types';
import Board, { components } from '../../../../../utils/lib/react-trello';
import './styles.less';

const { Card } = components;

Card.propTypes = {
    ...Card.propTypes,
    label: PropTypes.any,
    description: PropTypes.any,
    title: PropTypes.any,
}

const cardComponents = {
    ...components,
    Card,
};

const TicketBoard = (props) => {
    return (
        <Board {...props} components={cardComponents} className={`hms-ticket-board ${props.className}`}>{props.children}</Board>
    )
}
export default TicketBoard;
TicketBoard.propTypes = Board.propTypes;
TicketBoard.defaultProps = Board.defaultProps;
